import { render, staticRenderFns } from "./Ujian.vue?vue&type=template&id=b669a082&scoped=true"
import script from "./Ujian.vue?vue&type=script&lang=js"
export * from "./Ujian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b669a082",
  null
  
)

export default component.exports